import React from 'react';
import {
  Box,
  Flex,
  HStack,
  Button,
  Heading,
  Spacer,
  useDisclosure,
  IconButton,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  VStack,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { HamburgerIcon } from '@chakra-ui/icons';

const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Flex
        as="header"
        width="100%"
        align="center"
        padding="1.5rem"
        bg="rgba(255, 255, 255, 0.85)"  // Semi-transparent background
        color="blue.600"
        borderRadius="md"
        boxShadow="0 2px 10px rgba(0, 0, 0, 0.08)"
        borderBottom="1px"
        borderColor="gray.200"
        position="fixed"  // Changed from sticky to fixed
        top="0"
        left="0"
        right="0"
        zIndex="1000"
        backdropFilter="blur(10px)"  // Glassmorphic effect
        sx={{
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)"  // For Safari support
        }}
      >
        <Box p="2">
          <Link to="/">
            <Heading size="lg" color="blue.600">Abhishek Bhalerao</Heading>
          </Link>
        </Box>
        
        <Spacer />
        
        {/* Desktop Navigation */}
        <HStack spacing={4} display={{ base: 'none', md: 'flex' }}>
          <Link to="/">
            <Button colorScheme="blue" variant="ghost">
              Home
            </Button>
          </Link>
          <Link to="/about">
            <Button colorScheme="blue" variant="ghost">
              About
            </Button>
          </Link>
          <Link to="/projects">
            <Button colorScheme="blue" variant="ghost">
              Projects
            </Button>
          </Link>
          <Link to="/contact">
            <Button colorScheme="blue">
              Contact
            </Button>
          </Link>
        </HStack>
        
        {/* Mobile Navigation Button */}
        <IconButton
          aria-label="Open menu"
          icon={<HamburgerIcon />}
          display={{ base: 'flex', md: 'none' }}
          onClick={onOpen}
          colorScheme="blue"
          variant="ghost"
        />
      </Flex>

      {/* Mobile Navigation Drawer */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Menu</DrawerHeader>
          <DrawerBody>
            <VStack spacing={4} align="stretch" mt={4}>
              <Button as={Link} to="/" colorScheme="blue" variant="ghost" onClick={onClose}>
                Home
              </Button>
              <Button as={Link} to="/about" colorScheme="blue" variant="ghost" onClick={onClose}>
                About
              </Button>
              <Button as={Link} to="/projects" colorScheme="blue" variant="ghost" onClick={onClose}>
                Projects
              </Button>
              <Button as={Link} to="/contact" colorScheme="blue" onClick={onClose}>
                Contact
              </Button>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Header;







